import "client-only"

import { useConfigParams } from "./use-config-params"

export function useLoginRedirectUrl(additionalParams?: {
  [key: string]: string
}) {
  const { channel, authType } = useConfigParams()

  const urlSearchParams = new URLSearchParams()
  urlSearchParams.set("auth-type", authType)
  urlSearchParams.set("siteid", channel.toString())
  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      urlSearchParams.set(key, value)
    }
  }

  const url = new URL(window.APP_REDIRECT_LOGIN)
  url.search = urlSearchParams.toString()

  return url
}
